import React from 'react'
import {Helmet} from 'react-helmet'
import {useCustomPreferenceMarketless} from '../../hooks/use-custom-preference'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const SovendusLandingPageContainer = () => {
    const {locale} = useMultiSite()
    const localizer = locale?.alias?.split('-') || []
    const language = localizer[0] || ''
    //const country = localizer[1] || ''

    const sovendusConfiguration =
        useCustomPreferenceMarketless('sovendusConfiguration')?.[language] ?? {}
    return (
        <>
            {Object.keys(sovendusConfiguration).length > 0 && (
                <Helmet>
                    <script async defer src="https://api.sovendus.com/js/landing.js"></script>
                </Helmet>
            )}
        </>
    )
}

export default SovendusLandingPageContainer
